import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Menu from '../../../../components/layout/menu';
import { axiosInstance } from '../../../../client';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Types, IconTypes, VALID_TYPES } from '../../../../constants/announcementTypes';
import { downloadExcel } from '../../../../utils/xlsxUtils';
import CommonFields from '../../../../components/announcements/CommonFields';
import DropArea from '../../../../components/announcements/DropArea';
import RecentManuals from '../../../../components/announcements/RecentManuals';
import Modals from '../../../../components/announcements/Modals';
import dangerIcon from "../../../../assets/images/icons/announcements/danger.svg";
import alertIcon from "../../../../assets/images/icons/announcements/alert.svg";
import checkIcon from "../../../../assets/images/icons/announcements/check.svg";
import formIcon from "../../../../assets/images/icons/announcements/form.svg";
import { useAnnouncementValidation } from '../../../../hooks/announcements/useAnnouncementValidation';
import UploadDocumentButton from '../../../../components/shared/uploadDocument';
import DownloadDocumentButton from '../../../../components/shared/downloadDocument';
import ModalAlertWarning from '../../../../components/shared/modals/modalAlertWarning';

const SupplierItem = ({ supplier, onRemove }) => {
  const statusColor = supplier.isExisting ? 'bg-green' : 'bg-blue';
  const statusText = supplier.isExisting ? 'Existente' : 'Nuevo';

  return (
    <div className="flex items-center justify-between w-full gap-2 py-1 border-b border-[#808080]">
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full" style={{ backgroundColor: statusColor }}></div>
        <div>
          <p className="text-sm break-all font-itcmedium">
            {supplier.name} <span className='text-gray-700 font-itcbook'>({supplier.code})</span> 
          </p>
          <p className="text-xs break-all font-itcbook text-[#52526C]">
             {statusText}
          </p>
        </div>
      </div>
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="transition-colors text-red hover:text-red-700"
          title="Eliminar proveedor"
        >
          <svg width="16" height="16" viewBox="0 0 20 21" fill="currentColor">
            <path d="M12.7008 3.60083L12.945 5.29167H16.25C16.4158 5.29167 16.5747 5.35751 16.6919 5.47472C16.8092 5.59193 16.875 5.75091 16.875 5.91667C16.875 6.08243 16.8092 6.2414 16.6919 6.35861C16.5747 6.47582 16.4158 6.54167 16.25 6.54167H15.6092L14.8817 15.0292C14.8375 15.5458 14.8017 15.9708 14.7442 16.3142C14.6858 16.6717 14.5967 16.9917 14.4225 17.2883C14.149 17.7543 13.7424 18.1278 13.255 18.3608C12.945 18.5083 12.6183 18.5692 12.2567 18.5975C11.9092 18.625 11.4833 18.625 10.965 18.625H9.035C8.51667 18.625 8.09083 18.625 7.74333 18.5975C7.38167 18.5692 7.055 18.5083 6.745 18.3608C6.25757 18.1278 5.85098 17.7543 5.5775 17.2883C5.4025 16.9917 5.315 16.6717 5.25583 16.3142C5.19833 15.97 5.1625 15.5458 5.11833 15.0292L4.39083 6.54167H3.75C3.58424 6.54167 3.42527 6.47582 3.30806 6.35861C3.19085 6.2414 3.125 6.08243 3.125 5.91667C3.125 5.75091 3.19085 5.59193 3.30806 5.47472C3.42527 5.35751 3.58424 5.29167 3.75 5.29167H7.055L7.29917 3.60083L7.30833 3.55C7.46 2.89167 8.025 2.375 8.73333 2.375H11.2667C11.975 2.375 12.54 2.89167 12.6917 3.55L12.7008 3.60083Z"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default function AnnouncementsEdit() {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const today = new Date().toLocaleDateString('en-CA', {
    timeZone: 'America/Lima'
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [loadingData, setLoadingData] = useState(true);
  const [advertisement, setAdvertisement] = useState(null);
  
  const [activeTab, setActiveTab] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const excelInputRef = useRef(null);
  const dropInputRef = useRef(null);
  const [manuals, setManuals] = useState([]);
  const [selectedManualId, setSelectedManualId] = useState(null);
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [editorText, setEditorText] = useState('');
  const [characterCount, setCharacterCount] = useState(0);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [suppliers, setSuppliers] = useState([]);
  const [notFound, setNotFound] = useState([]);
  const [flaggedSuppliers, setFlaggedSuppliers] = useState([]);
  const [maxExceededSuppliers, setMaxExceededSuppliers] = useState([]);

  const [showNotFound, setShowNotFound] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [showMaxExceeded, setShowMaxExceeded] = useState(false);
  const [loading, setLoading] = useState(false);
const [downloadingTemplate, setDownloadingTemplate] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [allSuppliersList, setAllSuppliersList] = useState([]); 
  const [searchResults, setSearchResults] = useState([]);
  
const [hasUploadedExcel, setHasUploadedExcel] = useState(false);
const [initialData, setInitialData] = useState(null);
const [hasChanges, setHasChanges] = useState(false);
const [invalidSupplierCodes, setInvalidSupplierCodes] = useState([]);
const [showInvalidCodes, setShowInvalidCodes] = useState(false);

  const values = {
    activeTab,
    selectedManualId,
    selectedFile,
    previewUrl,
    title,
    summary,
    selectedIcon,
    editorText,
    fromDate,
    toDate,
    suppliers
  };

  const { isValid, errors } = useAnnouncementValidation(values, true);
const quillRef = useRef(null);

const handleKeyDown = (e) => {
  if (characterCount >= 500 && 
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) &&
      !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
  }
};

  useEffect(() => {
    if (id) {
      fetchAdvertisement();
    }
  }, [id]);

  const checkForChanges = () => {
    if (!advertisement) return false;
    
    let hasChanged = false;
    
    if (activeTab === Types.Recents) {
      const originalManualId = advertisement.manualId || null;
      hasChanged = selectedManualId !== originalManualId;
    } 
    else if ([Types.Image, Types.Pdf, Types.Video].includes(activeTab)) {
      const originalTitle = advertisement.title || '';
      const originalSummary = advertisement.summary || '';
      hasChanged = title !== originalTitle || summary !== originalSummary || selectedFile !== null;
    } 
    else if (activeTab === Types.Advertisement) {
      const originalIconId = advertisement.iconId || null;
      const originalDescription = advertisement.description || '';
      hasChanged = selectedIcon !== originalIconId || editorText !== originalDescription;
    }
    
    const originalFromDate = advertisement.advertisementSuppliers?.[0]?.startDate 
      ? advertisement.advertisementSuppliers[0].startDate.split('T')[0] 
      : today;
    const originalToDate = advertisement.advertisementSuppliers?.[0]?.endDate 
      ? advertisement.advertisementSuppliers[0].endDate.split('T')[0] 
      : today;
      
    hasChanged = hasChanged || fromDate !== originalFromDate || toDate !== originalToDate;
    
    if (hasUploadedExcel || suppliers.length !== advertisement.advertisementSuppliers?.length) {
      hasChanged = true;
    }
    
    return hasChanged;
  };

  useEffect(() => {
    if (advertisement && !loadingData) {
      const changed = checkForChanges();
      setHasChanges(changed);
    }
  }, [
    title, summary, selectedFile, selectedManualId, 
    selectedIcon, editorText, fromDate, toDate, 
    suppliers, hasUploadedExcel, advertisement, loadingData
  ]);

  const fetchAdvertisement = async () => {
    setLoadingData(true);
    try {
    const response = await axiosInstance.get(`/Advertisement/GetAdvertisement/${id}`);
    const ad = response.data;
    setAdvertisement(ad);
    
    const initialData = {
      title: ad.title || '',
      summary: ad.summary || '',
      selectedManualId: ad.manualId || null,
      selectedIcon: ad.iconId || null,
      editorText: ad.description || '',
      fromDate: ad.advertisementSuppliers?.[0]?.startDate 
        ? ad.advertisementSuppliers[0].startDate.split('T')[0] 
        : today,
      toDate: ad.advertisementSuppliers?.[0]?.endDate 
        ? ad.advertisementSuppliers[0].endDate.split('T')[0] 
        : today,
      suppliersCount: ad.advertisementSuppliers?.length || 0
    };
    
    setInitialData(initialData);
    setActiveTab(ad.typeId);

    if (ad.typeId === Types.Advertisement) {
      setSelectedIcon(ad.iconId || null);
      setEditorText(ad.description || '');
      
      if (ad.description) {
        const textOnly = ad.description.replace(/<[^>]*>/g, '');
        setCharacterCount(textOnly.length);
      }
    }
      
      if (ad.typeId === Types.Recents) {
        setSelectedManualId(ad.manualId || null);
      } else if ([Types.Image, Types.Pdf, Types.Video].includes(ad.typeId)) {
        setTitle(ad.title || '');
        setSummary(ad.summary || '');
        if (ad.file_url) {
          setPreviewUrl(ad.file_url);
        }
      } else if (ad.typeId === Types.Advertisement) {
        setSelectedIcon(ad.iconId || null);
        setEditorText(ad.description || '');
      }
      
      if (ad.advertisementSuppliers && ad.advertisementSuppliers.length > 0) {
        const supplier = ad.advertisementSuppliers[0];
        setFromDate(supplier.startDate ? supplier.startDate.split('T')[0] : today);
        setToDate(supplier.endDate ? supplier.endDate.split('T')[0] : today);
      }
      
      if (ad.advertisementSuppliers && ad.advertisementSuppliers.length > 0) {
        const supplierList = ad.advertisementSuppliers.map(as => ({
          id: as.supplier.id,
          name: as.supplier.name,
          code: as.supplier.code,
          isExisting: true,
          isInExcel: true,
        advertisementSupplierId: as.id, 
        startDate: as.startDate,
        endDate: as.endDate,
        category: 'assigned',

        }));
        setSuppliers(supplierList);
        setAllSuppliersList(supplierList);
        setSearchResults(supplierList);
      }
      
    } catch (error) {
      console.error('Error al cargar el anuncio:', error);
      setErrorMessage('No se pudo cargar el anuncio. Intenta de nuevo.');
      setShowError(true);
      setTimeout(() => navigate('/historial-anuncios'), 2000);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setSearchResults(allSuppliersList);
      return;
    }

    setIsSearching(true);
    
    const filtered = allSuppliersList.filter(supplier => 
      supplier.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      supplier.code.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    setSearchResults(filtered);
    setIsSearching(false);
    
    setShowSearchResults(searchTerm.trim().length > 0);
  }, [searchTerm, allSuppliersList]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleRemoveSupplier = (supplierId) => {
    const updatedSuppliers = suppliers.filter(s => s.id !== supplierId);
    setSuppliers(updatedSuppliers);
    
    const updatedAllSuppliers = allSuppliersList.filter(s => s.id !== supplierId);
    setAllSuppliersList(updatedAllSuppliers);
    
    if (searchTerm.trim()) {
      const filtered = updatedAllSuppliers.filter(supplier => 
        supplier.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier.code.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(filtered);
    }
  };

  useEffect(() => {
    if (activeTab === Types.Recents) fetchManuals();
  }, [activeTab]);

  const fetchManuals = async () => {
    setLoading(true);
    setShowError(false);
    try {
      const res = await axiosInstance.get('/Manual/ListManuals');
      setManuals(res.data.manuals);
    } catch {
      setErrorMessage('No se pudieron cargar los manuales.');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const preventDefaults = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = e => {
    preventDefaults(e);
    const file = e.dataTransfer.files[0];
    handleFileChange(file);
  };

  const handleFileChange = file => {
    if (!file) return;

    const allowed = VALID_TYPES[activeTab] || [];

    if (!allowed.includes(file.type)) {
      let formatErrorMessage = '';
      
      switch(activeTab) {
        case Types.Image:
          formatErrorMessage = 'Formato no permitido. Solo se permiten archivos de imagen: JPG, JPEG, PNG, WEBP o SVG.';
          break;
        case Types.Pdf:
          formatErrorMessage = 'Formato no permitido. Solo se permiten archivos PDF.';
          break;
        case Types.Video:
          formatErrorMessage = 'Formato no permitido. Solo se permiten archivos de video: GIF, MOV o MP4.';
          break;
        default:
          formatErrorMessage = 'Formato no permitido.';
      }
      
      setErrorMessage(formatErrorMessage);
      setShowError(true);
      if (dropInputRef.current) dropInputRef.current.value = '';
      return;
    }

    const maxSize = 50 * 1024 * 1024; 
    if (file.size > maxSize) {
      let sizeErrorMessage = '';
      
      switch(activeTab) {
        case Types.Image:
          sizeErrorMessage = 'Tamaño no permitido. Solo se permiten archivos de imagen de hasta 50 MB como máximo.';
          break;
        case Types.Pdf:
          sizeErrorMessage = 'Tamaño no permitido. Solo se permiten archivos PDF de hasta 50 MB como máximo.';
          break;
        case Types.Video:
          sizeErrorMessage = 'Tamaño no permitido. Solo se permiten archivos de video de hasta 50 MB como máximo.';
          break;
        default:
          sizeErrorMessage = 'Tamaño no permitido. El archivo excede el límite de 50 MB.';
      }
      
      setErrorMessage(sizeErrorMessage);
      setShowError(true);
      if (dropInputRef.current) dropInputRef.current.value = '';
      return;
    }

    setSelectedFile(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
  };

  const handleExcelChange = async e => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.oasis.opendocument.spreadsheet'
    ];
    const validExts = ['xls', 'xlsx', 'ods'];
    const ext = file.name.split('.').pop().toLowerCase();

    if (
      !validTypes.includes(file.type) &&
      !validExts.includes(ext)
    ) {
      setErrorMessage('Formato no válido. Usa XLS, XLSX u ODS.');
      setShowError(true);
      if (excelInputRef.current) excelInputRef.current.value = '';
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axiosInstance.post(
        `/Advertisement/ReUploadExcel/${id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      const { suppliers, summary } = response.data;

      if (summary.invalidSupplierCodes && summary.invalidSupplierCodes.length > 0) {
        setInvalidSupplierCodes(summary.invalidSupplierCodes);
        setShowInvalidCodes(true); 
      }
      
      const allSuppliers = [
        ...suppliers.assigned.map(supplier => ({
          id: supplier.id,
          code: supplier.code,
          name: supplier.name,
          isExisting: supplier.isExisting,
          isInExcel: supplier.isInExcel,
          email: supplier.email || null,
          advertisementSupplierId: supplier.advertisementSupplierId || null,
          startDate: supplier.startDate || null,
          endDate: supplier.endDate || null,
          category: 'assigned' 
        })),
        ...suppliers.noAssigned.map(supplier => ({
          id: supplier.id,
          code: supplier.code,
          name: supplier.name,
          isExisting: supplier.isExisting,
          isInExcel: supplier.isInExcel,
          email: supplier.email || null,
          advertisementSupplierId: supplier.advertisementSupplierId || null,
          startDate: supplier.startDate || null,
          endDate: supplier.endDate || null,
          category: 'noAssigned' 
        }))
      ];
      
      setSuppliers(allSuppliers);
      setAllSuppliersList(allSuppliers);
      setSearchResults(allSuppliers);
      setHasUploadedExcel(true);
      
      setSearchTerm('');
      setShowSearchResults(false);
      
    } catch (error) {
      console.error('Error al procesar el archivo Excel:', error);
      
      let errorMsg = 'Error al procesar el archivo Excel.';
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error.message) {
        errorMsg = error.message;
      }
      
      setErrorMessage(errorMsg);
      setShowError(true);
    } finally {
      setLoading(false);
      if (excelInputRef.current) excelInputRef.current.value = '';
    }
  };
useEffect(() => {
  if (activeTab === Types.Advertisement && editorText) {
    const textOnly = editorText.replace(/<[^>]*>/g, '');
    setCharacterCount(textOnly.length);
  }
}, [editorText, activeTab]);

  const handleUpdate = async () => {
  if (activeTab === Types.Advertisement) {
    if (characterCount > 500) {
      setErrorMessage(`Has excedido el límite de 500 caracteres. Tienes ${characterCount} caracteres.`);
      setShowError(true);
      return;
    }
  }
    if (!isValid) {
      const firstError = errors[Object.keys(errors)[0]];
      setErrorMessage(firstError);
      setShowError(true);
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      
      formData.append('typeId', activeTab);
      
      if (activeTab === Types.Recents) {
        formData.append('manualId', selectedManualId);
      } else if ([Types.Image, Types.Pdf, Types.Video].includes(activeTab)) {
        formData.append('title', title);
        formData.append('summary', summary);
        
        if (selectedFile) {
          formData.append('file', selectedFile);
        }
      } else if (activeTab === Types.Advertisement) {
        formData.append('iconId', selectedIcon);
        formData.append('description', btoa(unescape(encodeURIComponent(editorText))));
      }

      formData.append('fromDate', fromDate);
      formData.append('toDate', toDate);
      
    if (suppliers.length > 0) {
      const supplierIds = suppliers.map(s => s.id);
      supplierIds.forEach((supplierId, index) => {
        formData.append(`suppliers[${index}]`, supplierId.toString());
      });
    } else {
      formData.append('suppliers', JSON.stringify([]));
    }

      for (let pair of formData.entries()) {
        const key = pair[0];
        let value = pair[1];
        
        if (key === 'file') {
          value = `File: ${value.name} (${value.type}, ${value.size} bytes)`;
        } else if (key === 'description') {
          value = `Base64 encoded (${value.length} caracteres)`;
        }
        
      }

      await axiosInstance.put(`/Advertisement/UpdateAdvertisement/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      setSuccessMessage('¡Anuncio actualizado con éxito!');
      setShowSuccess(true);
      
      await fetchAdvertisement();

      
    } catch (error) {
      console.error('Error al actualizar el anuncio:', error);
      
      let errorMsg = 'No se pudo actualizar el anuncio. Intenta de nuevo.';
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error.message) {
        errorMsg = error.message;
      }
      
      setErrorMessage(errorMsg);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async (e) => {
    e.preventDefault();

    try {
      setDownloadingTemplate(true);
      const response = await axiosInstance.get('/Advertisement/ExportTemplate', {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Plantilla_de_proveedores.xlsx';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      setErrorMessage('No se pudo descargar el archivo, intenta de nuevo.');
      setShowError(true);
    } finally {
      setDownloadingTemplate(false);
    }
  };

  const handleDownloadFlagged = () => downloadExcel('proveedores_excedidos.xlsx', [
    ['Código', 'Razón Social', 'Cantidad de Anuncios Activos'],
    ...flaggedSuppliers.map(s => [s.supplierCode, s.supplierName, s.activeAdsCount])
  ]);

  const handleDownloadMaxExceeded = () => downloadExcel('proveedores_excedidos.xlsx', [
    ['Código', 'Razón Social', 'Cantidad de Anuncios Activos'],
    ...maxExceededSuppliers.map(s => [s.supplierCode, s.supplierName, s.activeAdsCount])
  ]);

  const getTypeName = () => {
    switch(activeTab) {
      case Types.Image: return 'Imagen';
      case Types.Pdf: return 'PDF';
      case Types.Advertisement: return 'Anuncio';
      case Types.Video: return 'Video';
      case Types.Recents: return 'Reciente';
      default: return 'Anuncio';
    }
  };

  if (loadingData) {
    return (
      <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
          <div className="flex items-center justify-center h-screen">
            <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            <span className="ml-3 text-blue">Cargando anuncio...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!advertisement && !loadingData) {
    return (
      <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
          <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%]">
            <div className="p-4 text-center bg-white rounded-lg shadow">
              <h2 className="text-xl text-red-600">Anuncio no encontrado</h2>
              <p className="mt-2 text-gray-600">El anuncio que intentas editar no existe o fue eliminado.</p>
              <button
                onClick={() => navigate('/historial-anuncios')}
                className="px-4 py-2 mt-4 text-white bg-blue-600 rounded hover:bg-blue-700"
              >
                Volver al Historial
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-2">
          <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">Editar Anuncio</h1>
          <p className="text-[#6B7280] font-itcbook text-lg md:text-xl leading-snug">
            Editando anuncio de tipo: <span className="font-itcmedium">{getTypeName()}</span>
          </p>
          
          <div className="mt-1">
            {activeTab === Types.Image && (
              <>
                <p className="text-[#6B7280] pb-2 font-itcbook text-base leading-snug mb-1">
                  Recuerda usar formatos como JPG, JPEG, PNG, WEBP o SVG (máx. 50 MB)
                </p>
                <DropArea
                  accept={VALID_TYPES[activeTab].join(',')}
                  selectedFile={selectedFile || previewUrl} 
                  onDrop={handleDrop}
                  onChange={e => handleFileChange(e.target.files[0])}
                  icon={
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7h2l2-3h10l2 3h2a1 1 0 011 1v11a1 1 0 01-1 1H3a1 1 0 01-1-1V8a1 1 0 011-1zm9 3a3 3 0 100 6 3 3 0 000-6z" />
                    </svg>
                  }
                  text={previewUrl ? "Arrastra o haz clic para cambiar la imagen" : "Arrastra o haz clic para cargar una imagen"}
                  preventDefaults={preventDefaults}
                  previewUrl={previewUrl}
                  setPreviewUrl={setPreviewUrl}
                  inputRef={dropInputRef}
                />
                <CommonFields title={title} setTitle={setTitle} summary={summary} setSummary={setSummary} />
              </>
            )}
            {activeTab === Types.Pdf && (
              <>
                <p className="text-[#6B7280] text-base font-itcbook  leading-snug mb-1">
                  Recuerda usar solo el formato PDF (máx. 50 MB)
                </p>
                <DropArea
                  accept={VALID_TYPES[activeTab].join(',')}
                  selectedFile={selectedFile || previewUrl} 
                  onDrop={handleDrop}
                  onChange={e => handleFileChange(e.target.files[0])}
                  icon={
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 2v6h6" />
                    </svg>
                  }
                  text={previewUrl ? "Arrastra o haz clic para cambiar el PDF" : "Arrastra o haz clic para cargar un archivo PDF"}
                  preventDefaults={preventDefaults}
                  previewUrl={previewUrl}
                  setPreviewUrl={setPreviewUrl}
                  inputRef={dropInputRef}
                />
                <CommonFields title={title} setTitle={setTitle} summary={summary} setSummary={setSummary} />
              </>
            )}
            {activeTab === Types.Advertisement && (
              <div className="grid grid-cols-1 gap-4 lg:gap-6 sm:grid-cols-6">
                <div className="sm:col-span-2 md:col-span-1">
                  <p className="text-[#6B7280] font-itcbook text-base leading-snug mb-1">
                    Escoge un ícono: <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center justify-center p-4 bg-white rounded shadow h-80">
                    <div className="flex flex-col items-center gap-4">
                      {[
                        { key: IconTypes.Danger, src: dangerIcon, alt: "Peligro" },
                        { key: IconTypes.Alert, src: alertIcon, alt: "Alerta" },
                        { key: IconTypes.Check, src: checkIcon, alt: "Correcto" },
                        { key: IconTypes.Form, src: formIcon, alt: "Formulario" },
                      ].map((icon) => (
                        <div
                          key={icon.key}
                          onClick={() => setSelectedIcon(icon.key)}
                          className="relative cursor-pointer"
                        >
                          <img src={icon.src} alt={icon.alt} className="relative z-10 w-12 h-12" />
                          {selectedIcon === icon.key && (
                            <div className="absolute top-0 left-0 w-full h-full bg-[#abdaf1] opacity-60 rounded z-20" />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-span-1 sm:col-span-4 md:col-span-5">
                  <div className='flex items-center justify-between gap-2 mb-1'>
                    <p className="text-[#6B7280] font-itcbook text-base leading-snug ">
                      Escribe tu texto aqui: <span className="text-red-500">*</span>
                    </p>
                    <p className={`text-xs font-itcbook ${characterCount > 500 ? 'text-red-600' : 'text-[#6B7280]'}`}>
                      {characterCount}/500 caracteres
                    </p>
                  </div>
                  <div>

                  <style>
                      {`
                        .ql-container {
                          height: 278px !important;
                          min-height: 278x !important;
                          border-bottom-left-radius: 4px !important;
                          border-bottom-right-radius: 4px !important;
                          background-color: white;
                      }

                      .ql-editor {
                        min-height: 278px !important;
                        max-height: 278px !important;

                      }
                      .ql-toolbar {
                        border-top-right-radius: 4px !important;
                        border-top-left-radius: 4px !important;
                        background-color: white;
                      }
                      .quill {
                        border-radius: 4px !important;
                        --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
                        --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
                        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
                      }
                      `}
                  </style>
<div onKeyDown={handleKeyDown}>
  <ReactQuill
    ref={quillRef}
    theme="snow"
    value={editorText}
    onChange={(content) => {
      const textOnly = content.replace(/<[^>]*>/g, '');
      if (textOnly.length <= 500) {
        setEditorText(content);
        setCharacterCount(textOnly.length);
      }
    }}
  className="bg-white"

/>
</div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === Types.Video && (
              <>
                <p className="text-[#6B7280] mb-2 font-itcbook text-base leading-snug ">
                  Recuerda usar formatos como GIF, MOV o MP4 (máx. 50 MB)
                </p>
                <DropArea
                  accept={VALID_TYPES[activeTab].join(',')}
                  selectedFile={selectedFile || previewUrl} 
                  onDrop={handleDrop}
                  onChange={e => handleFileChange(e.target.files[0])}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      className="w-12 h-12 mb-2"
                      fill="none"
                    >
                      <polygon
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        points="7,28 7,4 19,4 25,10 25,28"
                      />
                      <polyline
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        points="19,4 19,10 25,10"
                      />
                      <polygon
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        points="19,18 14,21 14,15"
                      />
                    </svg>
                  }
                  text={previewUrl ? "Arrastra o haz clic para cambiar el video" : "Arrastra o haz clic para cargar un video"}
                  preventDefaults={preventDefaults}
                  previewUrl={previewUrl}
                  setPreviewUrl={setPreviewUrl}
                  inputRef={dropInputRef}
                />
                <CommonFields title={title} setTitle={setTitle} summary={summary} setSummary={setSummary} />
              </>
            )}
            {activeTab === Types.Recents && (
              <RecentManuals manuals={manuals} selectedId={selectedManualId} onSelect={setSelectedManualId} />
            )}
          </div>

          <div className="mt-4">
            <label className="block text-sm sm:text-base font-itcmedium text-[#6B7280] mb-2">Tiempo de publicación</label>
            <div className="flex flex-col gap-4 sm:flex-row">
              <div className="flex items-center flex-1 gap-2">
                <label className="whitespace-nowrap font-itcbook text-sm text-[#6B7280]">Desde</label>
                <input
                  type="date"
                  min={today}
                  value={fromDate}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md font-itcbook focus:outline-none focus:ring-2 focus:ring-blue"
                  onChange={e => setFromDate(e.target.value)}
                />
              </div>
              <div className="flex items-center flex-1 gap-2">
                <label className="whitespace-nowrap font-itcbook text-sm text-[#6B7280]">Hasta</label>
                <input
                  type="date"
                  min={fromDate}
                  value={toDate}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md font-itc-book focus:outline-none focus:ring-2 focus:ring-blue"
                  onChange={e => setToDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='flex flex-col items-start gap-3 py-3'>
            <UploadDocumentButton 
              text="Subir lista de proveedores"
              isEnabled={true}
              onClick={() => excelInputRef.current?.click()}
            />
            
            <input
              type="file"
              accept=".xlsx,.xls,.ods"
              className="hidden"
              ref={excelInputRef}
              onChange={handleExcelChange}
            />

              <DownloadDocumentButton 
              text="Descargar plantilla"
              onClick={handleDownloadTemplate}
              disabled={downloadingTemplate}
              loading={downloadingTemplate}
              hasData={true}
            />
          </div>

          {(hasUploadedExcel || (!loadingData && (allSuppliersList.length > 0 || advertisement?.advertisementSuppliers?.length === 0))) && (          <>
            {allSuppliersList.length > 0 && ( 
            <div className="relative w-full mb-4 sm:w-[380px]">
              <div className="flex items-center w-full gap-2">
                  <label className="whitespace-nowrap font-itcbook text-sm text-[#111928]">Buscar proveedor:</label>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Escribe nombre o código"
                    disabled={allSuppliersList === 0}
                    className="p-2 w-[230px] text-sm bg-transparent border rounded-lg placeholder:text-sm border-blue-light placeholder:font-itcbook font-itcbook focus:outline-none "
                  />
                </div>
            </div>
            )}


            <div className="p-4 bg-white border border-gray-200 rounded-md shadow">
              {(() => {
                if (allSuppliersList.length === 0) {
                  return (
                    <p className="text-gray-500 font-itcbook">
                      No hay proveedores cargados
                    </p>
                  );
                }
                const suppliersToDisplay = searchTerm.trim() ? searchResults : allSuppliersList;
                
                const assignedSuppliers = suppliersToDisplay.filter(supplier => 
                  supplier.advertisementSupplierId !== null && supplier.advertisementSupplierId !== undefined
                );
                
                const unassignedSuppliers = suppliersToDisplay.filter(supplier => 
                  supplier.advertisementSupplierId === null || supplier.advertisementSupplierId === undefined
                );
                        
                if (suppliersToDisplay.length === 0) {
                  return (
                    <p className="text-gray-500 font-itcbook">
                      {searchTerm.trim() 
                        ? 'No hay proveedores que coincidan con la búsqueda' 
                        : 'No hay proveedores cargados'
                      }
                    </p>
                  );
                }

                return (
                  <div className="flex flex-col gap-2">
                    {assignedSuppliers.length > 0 && (
                      <div>
                        <h5 className="mb-2 text-green font-itcmedium">
                          Asignados ({assignedSuppliers.length}):</h5>
                          {assignedSuppliers.map(supplier => (
                            <SupplierItem
                              key={supplier.id}
                              supplier={supplier}
                              onRemove={() => handleRemoveSupplier(supplier.id)}
                            />
                          ))}
                      </div>
                    )}
                    
                    {unassignedSuppliers.length > 0 && (
                      <div>
                        <h5 className="mb-2 text-blue-light font-itcmedium">
                          Por asignar ({unassignedSuppliers.length}):</h5>
                          {unassignedSuppliers.map(supplier => (
                            <SupplierItem
                              key={supplier.id}
                              supplier={supplier}
                              onRemove={() => handleRemoveSupplier(supplier.id)}
                            />
                          ))}
                      </div>
                    )}
                    
                    {searchTerm.trim() && assignedSuppliers.length === 0 && unassignedSuppliers.length === 0 && (
                      <p className="text-gray-500 font-itcbook">
                        No hay proveedores en ninguna categoría que coincidan con la búsqueda
                      </p>
                    )}
                  </div>
                );
              })()}
            </div>
          </>
          )}

          <div className="flex justify-center gap-4">
            <button
              onClick={handleUpdate}
              disabled={loading || !hasChanges}
              className={`
                px-8 py-2 text-sm text-white transition rounded-lg md:text-lg font-itcmedium
                ${loading || !hasChanges ? 'bg-gray-400 cursor-not-allowed' : 'bg-green hover:bg-green-600'}
              `}
            >
              {loading ? 'Actualizando...' : 'Actualizar'}
            </button>
            <button
              onClick={() => !loading && navigate('/historial-anuncios')}
              disabled={loading}
              className={`
                px-8 py-2 text-sm transition border-2 rounded-lg md:text-lg font-itcmedium
                ${loading 
                  ? 'border-gray-300 text-gray-400 cursor-not-allowed' 
                  : 'border-green text-green hover:border-green-600 hover:text-green-600'
                }
              `}>
              Cancelar
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-60">
          <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
          </svg>
        </div>
      )}

<ModalAlertWarning
  showModalAlertWarning={showInvalidCodes}
  closeModal={() => setShowInvalidCodes(false)}
  error={
    <div className="flex flex-col items-center">
      <p className="mb-4 text-center font-itcdemi">
        Proveedores no encontrados
      </p>
      <ul className="w-full overflow-auto list-disc list-inside font-itcbook max-h-60">
        {invalidSupplierCodes.map((code, i) => (
          <li key={i}>
            Código: {code}
          </li>
        ))}
      </ul>
    </div>
  }
  accept={() => setShowInvalidCodes(false)}
  color="#CA2D00"
/>

      <Modals
        showNotFound={showNotFound} notFound={notFound} onCloseNotFound={() => setShowNotFound(false)}
        showError={showError} errorMessage={errorMessage} onCloseError={() => setShowError(false)}
        showSuccess={showSuccess} successMessage={successMessage}   onCloseSuccess={() => {
    setShowSuccess(false); 
    navigate('/historial-anuncios'); 
  }}
        showConfirm={showConfirm} flaggedSuppliers={flaggedSuppliers} onConfirm={() => { setShowConfirm(false); }} onDownloadFlagged={handleDownloadFlagged} onCloseConfirm={() => setShowConfirm(false)}
        showMaxExceeded={showMaxExceeded} maxExceededSuppliers={maxExceededSuppliers} onDownloadMaxExceeded={handleDownloadMaxExceeded} onCloseMaxExceeded={() => setShowMaxExceeded(false)}
      />
    </div>
  );
}
